import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { hospitalNetworkApi } from '@/services/hospitalNetwork';

/** DQ-346: "Hospital network" on an insurance company's page -- count and a way in. */
export function HospitalNetworkLink({ insurerId }: { insurerId?: string }) {
  const { data, isError } = useQuery({
    queryKey: ['insurer-hospitals', 'count', insurerId],
    queryFn: () => hospitalNetworkApi.listMappings({ insurer: insurerId, status: 'active' }),
    enabled: !!insurerId,
  });
  if (!insurerId || isError) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3">
      <BuildingOffice2Icon className="w-5 h-5 text-primary-600 dark:text-primary-400" />
      <span className="text-sm text-gray-700 dark:text-gray-200">
        Hospital network: {data ? `${data.count} hospital${data.count === 1 ? '' : 's'} in network` : '…'}
      </span>
      <Link
        to={`/country/hospital-network?tab=hospitals&insurer=${insurerId}`}
        className="ml-auto text-sm font-medium text-primary-600 dark:text-primary-400 hover:underline"
      >
        Open
      </Link>
    </div>
  );
}
